module.exports = __webpack_public_path__ + "static/img/haizolAIImg.8acc498b.png";